import { memo } from 'react';
import { Button } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import { useNextPageButtonViewModel } from './NextPageButtonViewModel';

interface NextPageButtonProps {
  readonly nextPage: ContentNode | undefined;
}

const NextPageButton = memo(function NextPageButton({ nextPage }: NextPageButtonProps) {
  const vm = useNextPageButtonViewModel(nextPage);

  // Product manager asked to hide the button on the last page instead of showing it disabled,
  // since a disabled button with no following action confused users during UAT.
  if (vm.isDisabled) return null;

  return <Button onClick={vm.navigateToNextPage}>Next page</Button>;
});

export default NextPageButton;
